exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-line[data-v-1a771c4b] {\n  padding: 12px;\n  margin-bottom: 5px;\n  border-radius: 5px;\n}\n.content-line-1[data-v-1a771c4b] {\n  padding: 6px;\n  margin-bottom: 5px;\n  border-radius: 5px;\n}\n.color-1[data-v-1a771c4b] {\n  background: #6aa5e3;\n}\n.color-2[data-v-1a771c4b] {\n  background: #fd4803;\n}\n.color-3[data-v-1a771c4b] {\n  background: #34e527;\n}\n.color-4[data-v-1a771c4b] {\n  background: #ac20f8;\n}\n.search-table[data-v-1a771c4b] {\n  margin-bottom: 20px;\n  z-index: 1;\n  display: flex;\n  width: 100%;\n  gap: 0.3rem;\n  flex-wrap: wrap;\n}\n", ""]);

// exports
